import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Select } from "antd";
import { useState } from "react";
import { calculateSafetyMechanismsFromSpecialTreatments } from "@devowl-wp/react-cookie-banner";
import { useFormService } from "../../../../../contexts/formService.js";
import { useI18n } from "../../../../../contexts/i18n.js";
import { Notices } from "../../../../common/notices.js";
import { FormValueDifferFromTemplateTag, diffByJsonStringify } from "../../../valueDifferFromTemplateTag.js";
const FormServiceFieldGeneralDataProcessingCountries = ()=>{
    const { __ } = useI18n();
    const { essentialGroupId, iso3166OneAlpha2, predefinedDataProcessingInSafeCountriesLists, territorialLegalBasis } = useFormService();
    const [ref, setRef] = useState();
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues.group !== nextValues.group || prevValues.isProviderCurrentWebsite !== nextValues.isProviderCurrentWebsite || JSON.stringify(prevValues.dataProcessingInCountries) !== JSON.stringify(nextValues.dataProcessingInCountries) || JSON.stringify(prevValues.dataProcessingInCountriesSpecialTreatments) !== JSON.stringify(nextValues.dataProcessingInCountriesSpecialTreatments),
        children: ({ getFieldValue })=>{
            const unsafeCountries = getFieldValue("isProviderCurrentWebsite") ? [] : calculateSafetyMechanismsFromSpecialTreatments({
                predefinedDataProcessingInSafeCountriesLists,
                territorialLegalBasis,
                isDataProcessingInUnsafeCountries: true,
                service: {
                    dataProcessingInCountries: getFieldValue("dataProcessingInCountries"),
                    dataProcessingInCountriesSpecialTreatments: getFieldValue("dataProcessingInCountriesSpecialTreatments")
                }
            }).filter((mechanism)=>mechanism.startsWith("D"));
            return /*#__PURE__*/ _jsxs(Form.Item, {
                label: __("Data processing in countries"),
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "dataProcessingInCountries",
                        noStyle: true,
                        children: /*#__PURE__*/ _jsx(Select, {
                            mode: "multiple",
                            showSearch: true,
                            optionFilterProp: "children",
                            maxTagCount: "responsive",
                            allowClear: true,
                            children: Object.keys(iso3166OneAlpha2).map((code)=>/*#__PURE__*/ _jsx(Select.Option, {
                                    value: code,
                                    children: iso3166OneAlpha2[code]
                                }, code))
                        })
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: "description",
                        ref: setRef,
                        children: [
                            /*#__PURE__*/ _jsx(FormValueDifferFromTemplateTag, {
                                form: "service",
                                valueName: "dataProcessingInCountries",
                                widthOfRef: ref,
                                difference: diffByJsonStringify,
                                renderDiff: (value)=>/*#__PURE__*/ _jsx(Select, {
                                        mode: "multiple",
                                        disabled: true,
                                        value: value,
                                        children: Object.keys(iso3166OneAlpha2).map((code)=>/*#__PURE__*/ _jsx(Select.Option, {
                                                value: code,
                                                children: iso3166OneAlpha2[code]
                                            }, code))
                                    })
                            }),
                            __("Data is usually processed in the countries where the service has its headquarter or servers. You should check with your service provider where your users' data is processed.")
                        ]
                    }),
                    unsafeCountries.length > 0 && getFieldValue("group") === essentialGroupId && /*#__PURE__*/ _jsx(Notices, {
                        notices: [
                            {
                                message: __("A transfer of personal data (e.g. IP address of the website visitor) to third countries that are unsafe in terms of data protection law (%s), is only permitted with prior consent. Consequently, such a service can never be essential under data protection law, since essential services are used on a different (in the case, non-existent) legal basis. In practice, however, it will not always be possible to avoid such use.", unsafeCountries.map((country)=>iso3166OneAlpha2[country]).join(", ")),
                                severity: "warning"
                            }
                        ]
                    })
                ]
            });
        }
    });
};
export { FormServiceFieldGeneralDataProcessingCountries };
